import { mimeTypes } from "../consts";

const getExtension = (mime: string) => {
	const extension = mimeTypes[mime];

	if (extension) {
		return extension;
	}

	return "";
};

const convertMime = (extensions: string[] = []) => {
	return extensions.map(getExtension).filter(Boolean).join(", ");
};

export { getExtension, convertMime };
